import * as React from 'react'
import { classes } from 'typestyle'
import { renderPopular, deletePictureParams, replaceWkDomain } from '../../../../utils/tools'
import {ImageView} from '../ImageView/ImageView'
import * as Styles from './HomeSlideLecture.style'
import HomeType from '../../types/HomeType'
import { reportClickEvent } from '../../../../services/operationReport'
import { RegisterElement } from '../../../../services/hotspotReport'

export function HomeSlideLecture(props: {data: HomeType.Module}) {
    const { contents, name } = props.data

    const link = (item, index) => {

        reportClickEvent(RegisterElement.slideLecture_click, {
            index,
            url: item.url,
            ch_id: item.id,
            inviter_id: item.inviter_id,
            context: name
        })

        setTimeout(() => {
            location.assign(replaceWkDomain(item.url))
        }, 150)
    }

    return (
        <div>
          <div className={Styles.titleName}>{props.data.name}</div>
          <div className={Styles.SlideLectureContent}>
           {contents.map((item, index) => (
                <div className={Styles.SlideLectureContentItem} key={item.id} onClick={() => link(item, index)}>
                    <div className={Styles.itemCover}>
                        <div className={Styles.itemCoverWrap}>
                            <ImageView url={item.cover_url} width={300}/>
                        </div>
                       <img className={Styles.playBtn} src="https://static-cos.lycheer.net/picture/12209467_3af8357bb456c28c44d02553318ba349.jpg" alt=""/>
                    </div>
                    <div className={classes(Styles.itemTitle, 'TextChangeToTwoLines')}>
                        {item.title}
                    </div>
                    <div className={Styles.itemBottom}>
                      <img src="https://static-cos.lycheer.net/picture/10490565_5ddfe21b03842fa68973218ec2737646.jpg" alt=""/>
                      <i>{renderPopular(item.popular)}人</i>
                    </div>
                </div>
           ))}
          </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeSlideLecture/HomeSlideLecture.tsx